import { useState, useEffect } from "react";
import { Form, Input, Button, Upload as AntUpload, Card, message } from "antd";
import { Upload, CheckCircle, FileText, Loader2 } from "lucide-react";
import axios from '../../../services/axios';
import { useLocation, useNavigate } from 'react-router-dom';

const UploadDocumentForm = () => {
  const location = useLocation();
  const [fileList, setFileList] = useState([]);
  const [isReupload, setIsReupload] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const projectName = JSON.parse(localStorage.getItem('Project'))        
  const user = localStorage.getItem('user');
  const [originalDocumentCode, setOriginalDocumentCode] = useState('');

  useEffect(() => {

    if (location.state?.prefillData) {
      const prefillData = location.state.prefillData;
      setIsReupload(true);
      setOriginalDocumentCode(prefillData.originalDocumentCode);
      form.setFieldsValue({
        paymentReceiptRef: prefillData.paymentReceiptRef,
        ipcRef: prefillData.ipcRef,
        ipcAmount: prefillData.ipcAmount,
        paymentAmount: prefillData.paymentAmount,
        paymentReceiptDate: prefillData.paymentReceiptDate,
      });
    }
  }, [location.state, form]);

  const handleUpload = async (values) => {
    values.user = user;
    values.projectName = projectName;

    if (isReupload && originalDocumentCode) {
      values.code = originalDocumentCode;
    }
    if (fileList.length === 0) {
      message.warning("Please select a file.");
      return;
    }
  
    const formData = new FormData();
    formData.append("file", fileList[0]);
    const data = { ...values };
    formData.append("data", JSON.stringify(data));
    
    setLoading(true);
    try {
      if (isReupload) {
        await axios.post("/reupload-payment-receipt-document", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 600000
        } );
        message.success("File uploaded successfully!");
        form.resetFields();
        setFileList([]);
        setUploadSuccess(true);
        setTimeout(() => setUploadSuccess(false), 3000);
      } else {

      await axios.post("/upload-payment-receipt-document", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 600000,
      });
  
      message.success("File uploaded successfully!");
      form.resetFields();
      setFileList([]);
      setUploadSuccess(true);
      setTimeout(() => setUploadSuccess(false), 3000);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong2');
      }
    }
  };

  return (
    <div className="relative flex-1 p-5 overflow-y-auto ml-2 mr-2 min-h-screen">
      <div className="max-w-3xl mx-auto">
        {/* Heading */}
        {/* <h2 className="text-2xl font-semibold text-gray-800 flex items-center justify-center space-x-2 p-2">
          <FileText className="text-blue-500 w-6 h-6" />
          <span>{isReupload ? "Reupload Document" : "Upload Document"}</span>
        </h2> */}

        <Card className="shadow-md rounded-lg p-6">
          <Form form={form} layout="vertical"
            onFinish={handleUpload}>
            <Form.Item
              label="Payment Receipt Ref."
              name="paymentReceiptRef"
              rules={[{ required: true, message: "Please enter payment receipt ref." }]}
            >
              <Input placeholder="Enter document payment receipt ref." disabled={isReupload}/>
            </Form.Item>

            <Form.Item
              label="IPC Ref."
              name="ipcRef"
              rules={[{ required: true, message: "Please enter ipc ref." }]}
            >
              <Input placeholder="Enter ipc ref." disabled={isReupload}/>
            </Form.Item>

            <Form.Item
              label="IPC Amount"
              name="ipcAmount"
              rules={[{ required: true, message: "Please enter ipc amount" }]}
            >
              <Input placeholder="Enter ipc amount" type="number" disabled={isReupload}/>
            </Form.Item>

            <Form.Item
              label="Payment Amount"
              name="paymentAmount"
              rules={[{ required: true, message: "Please enter payment amount" }]}
            >
              <Input placeholder="Enter payment amount" type="number" disabled={isReupload}/>
            </Form.Item>

            <Form.Item
              label="Payment Reciept Date"
              name="paymentReceiptDate"
              rules={[{ required: true, message: "Please select a payment reciept date" }]}
            >
              <Input type="date" />
            </Form.Item>

            {/* Upload Section */}
            <Form.Item label="Upload File" name="uploadFile" rules={[{ required: true, message: "Please upload a file" }]}>
              <AntUpload
                fileList={fileList}
                beforeUpload={(file) => {
                  setFileList([file]);
                  return false;
                }}
                onRemove={() => setFileList([])}
              >
                <Button icon={<Upload className="w-4 h-4" />}>Upload File</Button>
              </AntUpload>
            </Form.Item>
            <Form.Item className="mb-0">
              <Button 
                type="primary"
                htmlType="submit"
                className="w-full h-10 flex items-center justify-center gap-2"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    <span>{isReupload ? "Reuploading..." : "Uploading..."}</span>
                  </>
                ) : (
                  isReupload ? "Reupload Document" : "Upload Document"
                )}
              </Button>
            </Form.Item>

            {uploadSuccess && (
              <div className="flex items-center gap-2 text-green-500 mt-4">
                <CheckCircle className="w-5 h-5" />
                <span>File uploaded successfully!</span>
              </div>
            )}
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default UploadDocumentForm;
